import { Customer, Invoice } from '../../types';
import {
  getScheduledCancellationDate,
  isInvoiceObligatory,
  isPlanAlreadyTerminated,
} from '../../utils';
import moment from 'moment';
import React from 'react';

export const CanceledBanner = (props: { customer: Customer; invoices: Invoice[] }) => {
  const { customer, invoices } = props;
  const scheduledCancellationDate = getScheduledCancellationDate(customer.activeSubscription);

  const text = isPlanAlreadyTerminated(customer.activeSubscription)
    ? 'Your plan has been canceled.'
    : scheduledCancellationDate !== null
    ? `Your plan has been canceled. It’s still available until the end of your billing period on ${moment(
        scheduledCancellationDate
      ).format('MMMM D, YYYY')}.`
    : null;

  const hasDueInvoices = invoices.filter(isInvoiceObligatory).length > 0;

  if (!text) return null;
  return (
    <div className="billing__cancelled-note" data-test="billing__cancelled-note">
      <span>{text}</span>
      {hasDueInvoices && (
        <span className="growegy-label14--weight500">
          Please ensure all open and past due invoices are paid promptly to avoid any negative
          impact on your credit score.
        </span>
      )}
    </div>
  );
};
